/**
 * Canonical forward-facing product mark for the K9 operations PWA / dashboard (APEX K9™).
 * Use Unicode U+2122 so manifests, emails, titles, and JSX text stay consistent.
 */
export const APEX_K9_MARK = 'APEX K9™';

/** Product name without trademark symbol — for composition where TM is added separately. */
export const APEX_K9_NAME = 'APEX K9';

/** Included agency K9 admin seat (does not count toward paid seats). */
export const APEX_K9_PRIMARY_ADMIN_LABEL = 'Primary K9 Admin';

/** Licensing summary line and team roster chip. */
export const APEX_K9_PRIMARY_ADMIN_FREE_LABEL = 'Primary K9 Admin (free)';

/** Transfer action (button / dialog title). */
export const APEX_K9_TRANSFER_PRIMARY_ADMIN_ACTION = 'Transfer Primary K9 Admin';
